import React from 'react';
import { Link } from 'react-router-dom';

export default class Answers extends React.Component {
  render() {
    return <div className="content">
      <h3 className="title is-3">Answers</h3>
      <h3 className="subtitle">Save an Answer</h3>
      <p>This section covers how to create an answer for an assessment</p>
      <p>NOTE: answers can be posted any number of times. Until the assessment is finished, any existing answer record will be overwritten.</p>

      <h3 className="subtitle">HTTP Request</h3>
      <p><code>POST https://api.ccihub.com/api/patients/{`{patient_id}`}/visits/{`{order}`}/assessment/{`{scale_id}`}/answers</code></p>
      
      <h3 className="subtitle">Request Parameters</h3>
      <table className="table">
        <thead>
          <th>Parameter</th>
          <th>Required</th>
          <th>Type</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>patient_id</td>
            <td>yes</td>
            <td>string</td>
            <td>The id of the patient</td>
          </tr>
          <tr>
            <td>order</td>
            <td>yes</td>
            <td>number</td>
            <td>The order of the visit</td>
          </tr>
          <tr>
            <td>scale_id</td>
            <td>yes</td>
            <td>number</td>
            <td>The scale_id of the assessment</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Answer Request Payload</h3>
      <div className="code-snippet">
<pre><code>
{`{
  question_id: '1a',
  answer: 'Yes',
  score: 0
}`}
</code></pre>
      </div>

      <h3 className="subtitle">Response</h3>
      <p><code>201 Created</code></p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Answers.js